import { render, staticRenderFns } from "./supervisionDetails.vue?vue&type=template&id=4e30b488&scoped=true"
import script from "./supervisionDetails.vue?vue&type=script&lang=js"
export * from "./supervisionDetails.vue?vue&type=script&lang=js"
import style0 from "./supervisionDetails.vue?vue&type=style&index=0&id=4e30b488&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e30b488",
  null
  
)

export default component.exports